<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/24spYG/tc-custom/9781614756538.jpg?1718046733124" alt="This image is the cover for the book Selected Stories: Science Fiction, Vol 1"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Selected Stories: Science Fiction, Vol 1
      </h1>
      <p class="bookDescription body article font2">
        <b>From a <i>New York Times–</i>bestselling author, sci-fi short stories spanning an award-winning career.</b><br/>  <br/> Kevin J. Anderson is one of the best-selling novelists working in the field today, but over the course of his long career he has also produced a steady stream of short fiction, ranging from hard science fiction, to fantasy, to horror, dark fantasy, and humor.<br/><br/> He has won or been nominated for the Hugo Award, Nebula Award, Bram Stoker Award, Shamus Award, Colorado Book Award, Scribe Award, <i>New York Times</i> Notable Book, and many others. This first volume of Anderson’s selected short fiction focuses on his science fiction stories, from flash fiction to novella length, written solo or with collaborators.<br/><br/> These stories showcase his writing talent across a range of military science fiction, dystopian fiction, space adventure, humor, alternate timelines, and political and psychological extrapolation. 
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Kevin J. Anderson
      </h2>
      
      <p class="authorDescription body article">Kevin J. Anderson has published more than 170 books, 58 of which have been national or international bestsellers. He has written numerous novels in the Star Wars, X-Files, and Dune universes, as well as unique steampunk fantasy novels Clockwork Angels andClockwork Lives, written with legendary rock drummer Neil Peart. His original works include the Saga of Seven Suns series, the Wake the Dragon and Terra Incognita fantasy trilogies, the Saga of Shadows trilogy, and his humorous horror series featuring Dan Shamble, Zombie PI. He has edited numerous anthologies, written comics and games, and the lyrics to two rock CDs. Anderson is the director of the graduate program in Publishing at Western Colorado University. Anderson and his wife Rebecca Moesta are the publishers of WordFire Press. His most recent novels are Vengewar, Dune: The Duke of Caladan (with Brian Herbert), Stake, Kill Zone (with Doug Beason), and Spine of the Dragon.</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      WordFire Press
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?0cd1a384